module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.e5cc188.eot";